import { InputStatus } from 'antd/lib/_util/statusUtils';
import { useEffect, useState } from 'react';

export const COUNTRY_CODES = ['+45'];
export const COUNTRY_CODE_OPTIONS = COUNTRY_CODES.map(s => ({ value: s, label: s }));

export const useHandlePhoneNumberInputChange = (value?: string, onChange?: (text?: string) => void) => {
  const countryCode = COUNTRY_CODE_OPTIONS[0].value;
  const [phoneNumber, setPhoneNumber] = useState(value);
  const [valid, setValid] = useState(true);

  const handleChangeEvent = (numberValue?: string, codeValue = countryCode) => {
    const stripped = (numberValue ?? '').replace(/[^0-9]/g, '');
    const isValid = !!codeValue && stripped?.length === 8;

    setPhoneNumber(stripped);
    setValid(isValid);
    onChange?.(isValid ? `${codeValue}${stripped}` : '');
  };

  useEffect(
    function setDefaultValue() {
      const formattedValue = `${countryCode}${phoneNumber}`;
      if (value && formattedValue !== value) {
        setPhoneNumber(value);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );

  const status = (!valid ? 'error' : undefined) as InputStatus;

  return {
    phoneNumber,
    status,
    handleChangeEvent,
    countryCode,
  };
};
